<template>
  <a-layout-footer class="footer">
    <div class="container">
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="footer-column">
            <h3 class="footer-logo">{{ companys.sub_name }}</h3>
            <p class="footer-tagline">{{ companys.summary }}</p>
            <div class="footer-contact">
              <p>
                <EnvironmentOutlined /> {{ companys.address }}
              </p>
              <p>
                <PhoneOutlined /> {{ companys.phone }}
              </p>
              <p>
                <MailOutlined /> {{ companys.email }}
              </p>
            </div>
            <div class="footer-social">
              <FacebookOutlined class="social-icon" />
              <InstagramOutlined class="social-icon" />
              <YoutubeOutlined class="social-icon" />
              <TwitterOutlined class="social-icon" />
            </div>
          </div>
        </a-col>
       <a-col
        v-for="(menu, index) in menuFooter"
        :key="index"
        :xs="24"
        :sm="12"
        :md="6"
        :lg="6"
      >
        <div class="footer-column">
          <h4 class="footer-title">{{ menu.linkLabel }}</h4>

          <ul class="footer-links">
            <li
              v-for="(child, cindex) in menu.children"
              :key="cindex"
            >
              <router-link :to="child.linkTo">
                {{ child.linkLabel }}
              </router-link>
            </li>
          </ul>
        </div>
      </a-col>
        <!-- <a-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="footer-column">
            <h4 class="footer-title">TÀI KHOẢN</h4>
            <ul class="footer-links">
              <li><a href="#">Đăng nhập</a></li>
              <li><a href="#">Đăng ký</a></li>
              <li><a href="#">Giỏ hàng</a></li>
              <li><a href="#">Kiểm tra đơn hàng</a></li>
            </ul>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="footer-column">
            <h4 class="footer-title">CHĂM SÓC KHÁCH HÀNG</h4>
            <ul class="footer-links">
              <li><a href="#">Hướng dẫn mua hàng</a></li>
              <li><a href="#">Hướng dẫn thanh toán</a></li>
              <li><a href="#">Chính sách đổi trả</a></li>
              <li><a href="#">Hướng dẫn bảo hành</a></li>
              <li><a href="#">Chính sách giao hàng</a></li>
              <li><a href="#">Câu hỏi thường gặp</a></li>
            </ul>
          </div>
        </a-col> -->
      </a-row>
      <div class="footer-bottom">
        <p>Copyright © Kima Home 2021. All Rights Reserved.</p>
      </div>
    </div>
  </a-layout-footer>
</template>

<script lang="ts" setup>
import { watch, reactive, ref, onMounted, computed } from "vue";
import store from "@/store";
import commons from "@/utils/Common";
import { COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
import { apiPost, apiGetNoParam, apiRedis } from "@/api/index";

import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  TwitterOutlined
} from '@ant-design/icons-vue'
const companys = ref({
  summary: "",
  sub_name: "",
  address: "",
  phone: "",
  name: "",
  description: "",
  logo: "",
  id: null,
  email: ""
})

onMounted(()=> {
  loadMenuFooter()
  cokiesCompany()
})

const cokiesCompany = () => {
       let data = commons.getCokiesCompany()
        companys.value  = data
}

const isLCompanyInfor = computed(() => {
    return store.getters.isLCompanyInfor;
});
watch(isLCompanyInfor, async (newValue, oldValue) => {
  cokiesCompany()
});

const menuFooter = ref([])

const loadMenuFooter = async () => {
  await apiRedis("default-fotter").then((res) => {
    let response: any = res;
    let data = response.data.data
    if (typeof data === "string") {
      data = JSON.parse(data)
    }
    menuFooter.value = data || []

    console.log("menuFooter", menuFooter.value)
  
  });
}
</script>

<style scoped>
.footer {
  background: var(--primary-dark);
  color: var(--text-white);
  padding: 60px 0 20px;
}

.footer-column {
  margin-bottom: 30px;
  text-align: left;
}

.footer-logo {
  font-size: 32px;
  font-weight: 400;
  color: var(--primary-gold);
  margin-bottom: 6px;
  letter-spacing: 3px;
  font-family: 'Playfair Display', serif;
  font-style: normal;
  line-height: 1.2;
}

.footer-tagline {
  font-size: 11px;
  color: var(--primary-gold);
  letter-spacing: 5px;
  margin-bottom: 24px;
  text-transform: uppercase;
  font-weight: 300;
  font-family: 'Lato', sans-serif;
}

.footer-contact p {
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.footer-contact :deep(.anticon) {
  color: var(--primary-gold);
  margin-top: 4px;
}

.footer-social {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.social-icon {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: color 0.3s;
}

.social-icon:hover {
  color: var(--primary-gold);
}

.footer-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-white);
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: var(--primary-gold);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  margin-top: 40px;
  text-align: center;
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin: 0;
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }
  
  .footer-column {
    margin-bottom: 40px;
  }
}
</style>
